import * as React from 'react';

import { DASHBOARD_DEGRADED_WARNING } from 'src/ui/constants/testIds';
import { copy } from 'src/ui/templates/copy';
import { buildRoute } from 'src/ui/utils/buildRoute';

interface DegradedWarningProps {
  index: number;
  org: string | undefined;
}

/**
 * This uses just a plain button as we use an image to display the actual
 * button. We don't want this to be styled by blueprintjs.
 */
export const DegradedWarning: React.VFC<DegradedWarningProps> = ({
  index,
  org,
}) => {
  return (
    <div className="sd-warning">
      {copy.errors.degraded.before}
      &nbsp;
      <a
        href={buildRoute(org, index, 'configuration')}
        data-testid={DASHBOARD_DEGRADED_WARNING}
      >
        {copy.errors.degraded.link}
      </a>
      &nbsp;
      {copy.errors.degraded.after}
    </div>
  );
};
